// CardRoutes.js
import React from "react";
import { Route, Routes } from "react-router-dom";
import ROUTES_NAVIGATION from "./routes";
import DealerList from "../components/DealerManagement/Admin/DealerManagement/Dealer/DealerList";
import AddNewDealer from "../components/DealerManagement/Admin/DealerManagement/Dealer/AddDealer";
import DealerBranchList from "../components/DealerManagement/Admin/DealerManagement/DealerBranch/DealerBranchList";
import AddNewDealerBranch from "../components/DealerManagement/Admin/DealerManagement/DealerBranch/AddDealerBranch";
import BusinessPartnerTypeList from "../components/DealerManagement/Admin/DealerManagement/BusinessPartnerType/BusinessPartnerTypeList";
import AddNewBusinessPartnerType from "../components/DealerManagement/Admin/DealerManagement/BusinessPartnerType/AddBusinessPartnerType";
import DepartmentList from "../components/DealerManagement/Admin/DealerManagement/Department/DepartmentList";
import AddNewDepartment from "../components/DealerManagement/Admin/DealerManagement/Department/AddDepartment";
import RTOList from "../components/DealerManagement/Admin/DealerManagement/RTO/RTOList";
import AddNewRTO from "../components/DealerManagement/Admin/DealerManagement/RTO/AddRTO";
import BusinessPartnerList from "../components/DealerManagement/Admin/DealerManagement/BusinessPartner/BussinessPartnerList";
import AddNewBusinessPartner from "../components/DealerManagement/Admin/DealerManagement/BusinessPartner/AddBusinessPartner";
import EditDealer from "../components/DealerManagement/Admin/DealerManagement/Dealer/EditDealer";
import EditDepartment from "../components/DealerManagement/Admin/DealerManagement/Department/EditDepartment";
import EditBusinessPartnerType from "../components/DealerManagement/Admin/DealerManagement/BusinessPartnerType/EditBusinessPartnerType";
import EditDealerBranch from "../components/DealerManagement/Admin/DealerManagement/DealerBranch/EditDealerBranch";
import EditRTO from "../components/DealerManagement/Admin/DealerManagement/RTO/EditRTO";



const DealerRoutes = () => {
  return (
    <>
      <Route
        path={ROUTES_NAVIGATION.BUSSINESSPARTNER}
        element={<BusinessPartnerList />}
      />
      <Route
        path={ROUTES_NAVIGATION.ADDBUSSINESSPARTNER}
        element={<AddNewBusinessPartner />}
      />
      <Route
        path={ROUTES_NAVIGATION.DEALERLIST}
        element={<DealerList />}
      />
      <Route
        path={ROUTES_NAVIGATION.ADDDEALER}
        element={<AddNewDealer />}
      />
      <Route
        path={ROUTES_NAVIGATION.DEALERBRANCHLIST}
        element={<DealerBranchList />}
      />
      <Route
        path={ROUTES_NAVIGATION.ADDDEALERBRANCH}
        element={<AddNewDealerBranch />}
      />
      <Route 
      path={ROUTES_NAVIGATION.EDITDEALERBRANCH}
      element= { <EditDealerBranch /> }
      />
       <Route
        path={ROUTES_NAVIGATION.EDITDEALER}
        element={<EditDealer />}
      />
       <Route
        path={ROUTES_NAVIGATION.BUSINESSPARTNERTYPELIST}
        element={<BusinessPartnerTypeList />}
      />
      <Route
        path={ROUTES_NAVIGATION.ADDBUSINESSPARTNERTYPELIST}
        element={<AddNewBusinessPartnerType />}
      />
       <Route
        path={ROUTES_NAVIGATION.EDITBUSINESPARTNERTYPE}
        element={<EditBusinessPartnerType />}
      />
       <Route
        path={ROUTES_NAVIGATION.DEPARTMENT}
        element={<DepartmentList />}
      />
      <Route
        path={ROUTES_NAVIGATION.ADDDEPARTMENT}
        element={<AddNewDepartment />}
      />
       <Route
        path={ROUTES_NAVIGATION.EDITDEPARTMENT}
        element={<EditDepartment />}
      />
       <Route
        path={ROUTES_NAVIGATION.RTOLIST}
        element={<RTOList />}
      />
      <Route
        path={ROUTES_NAVIGATION.ADDRTO}
        element={<AddNewRTO />}
      />
     
     <Route
     path={ROUTES_NAVIGATION.EDITRTO}
     element={<EditRTO />}
     />

      
    </>
  );
};

export default DealerRoutes;
